<template>
  <form
    id="mortgage-form"
    @submit.prevent
  >
    <input
      id="leadid_token"
      ref="leadDiv"
      name="universal_leadid"
      type="hidden"
      value=""
    >
    <div
      v-if="step === 'property-zip'"
      class="step"
    >
      <h2 class="step__title first__title">Start by entering your zip code:</h2>
      <div class="step__body">
        <input-zip
          :zip="formData.zipCode"
          @input="handleLocationData"
          @valid="handleInputValidity"
        />
        <next-step
          @nextStep="handleNextStep"
        >Continue</next-step>
      </div>
    </div>
    <div
      v-else-if="step === 'electric-bill'"
      class="step"
    >
      <h2 class="step__title">How high is the Electric bill you have?
        <div class="step__subtitle">
          Reduce your electrical bill by up to 50%
        </div>
      </h2>
      <div class="step__body">
        <electric-bill
          v-model="formData.electricBill"
        />
        <next-step @nextStep="nextStep">Continue</next-step>
      </div>
    </div>
    <div
      v-else-if="step === 'home-owner'"
      class="step"
    >
      <h2 class="step__title">Are you a homeowner?</h2>
      <div class="step__body">
        <home-owner
          v-model="formData.propertyOwnership"
          @input="nextStep"
        />
      </div>
    </div>
    <div
      v-else-if="step === 'shade'"
      class="step"
    >
      <h2 class="step__title">Is your home shaded?
        <div class="step__subtitle">Provide clean, reliable energy for your family</div>
      </h2>
      <div class="step__body">
        <shade
          v-model="formData.roofShade"
          @input="nextStep"
        />
      </div>
    </div>
    <div
      v-else-if="step === 'personal-info'"
      class="step"
    >
      <h2 class="step__title">What is your name?
        <div class="step__subtitle">(your personal information is safe and secure)</div>
      </h2>

      <div class="step__body">
        <f-name
          ref="InputFirstName"
          v-model="formData.firstName"
          :first-name="formData.firstName"
          @valid="handleInputValidity"
        />
        <l-name
          ref="InputLastName"
          v-model="formData.lastName"
          :last-name="formData.lastName"
          @valid="handleInputValidity"
        />
        <next-step @nextStep="handleNextStep">Continue</next-step>
      </div>
    </div>
    <div
      v-else-if="step === 'personal-contacts'"
      class="step"
    >
      <h2 class="step__title"><span class="text--capitalize">{{ formData.firstName }}</span>, Last Step!
        <div class="step__subtitle">Complete this final step to see your savings</div>
      </h2>
      <div class="step__body">
        <input-email
          ref="InputEmail"
          v-model="formData.email"
          :email-prop="formData.email"
          @valid="handleInputValidity"
        />
        <input-usphone
          ref="InputUsPhone"
          v-model="formData.usPhone"
          :phone-prop="formData.usPhone"
          @valid="handleInputValidity"
        />
        <finish-button @nextStep="handleNextStep">VIEW MY QUOTES</finish-button>
        <span class="secure__box">
          <img
            src="../assets/img/lock-small.svg"
            alt="secure"
          >
          Your information is secure.</span>
        <p class="disclaimer">
          <input
            id="leadid_tcpa_disclosure"
            type="hidden"
          ><label for="leadid_tcpa_disclosure">
            By clicking above, you authorize CheckSolarSavings and up to four <a
              href="../img/partners.png"
              target="_blank"
            >Solar Companies </a> to call you and send you pre-recorded
            messages and text messages at the number you entered above, using an autodialer, with offers about their products or services,
            even if your phone number is on any national or state “Do Not Call” list. Message and data rates may apply. Your consent here is not based on a condition of purchase.

      </label></p></div>
    </div>
  </form>
</template>

<script>
import axios from 'axios'

import InputUsZip from './form-elements/InputUsZip'
import BtnNextStep from './form-elements/BtnNextStep'
import BtnFinish from './form-elements/BtnFinish'
import ElectricBill from './form-elements/ElectricBill'
import HomeOwner from './form-elements/HomeOwner'
import Shade from './form-elements/Shade'
import InputFirstName from './form-elements/InputFirstName'
import InputLastName from './form-elements/InputLastName'
import InputUsPhone from './form-elements/InputUsPhone'
import InputEmail from './form-elements/InputEmail'
import Loader from './form-elements/Loader'

export default {
  components: {
    'input-zip': InputUsZip,
    'next-step': BtnNextStep,
    'electric-bill': ElectricBill,
    'home-owner': HomeOwner,
    'shade': Shade,
    'f-name': InputFirstName,
    'l-name': InputLastName,
    'input-usphone': InputUsPhone,
    'input-email': InputEmail,
    'finish-button': BtnFinish,
    'loader': Loader
  },
  props: {
    step: {
      type: String,
      default: 'property-zip'
    }
  },
  data () {
    return {
      formData: {},
      validInputs: {}
    }
  },
  computed: {
    skipToNext (val) {
      if ((this.formData.propertyValue * 0.9) - this.formData.mortgageBalance < 10000) {
        this.formData.cashout = 0
        this.$emit('skipToNext', this.formData)
        return false
      } else {
        return true
      }
    }
  },
  mounted () {
    let local = JSON.parse(localStorage.getItem('formInfo'))
    if (local) {
      this.formData = local
    }
  },
  methods: {
    handleUpdate (name, val) {
      this.formData.name = val
    },
    handleLocationData (zip, city, state, payout) {
      this.formData.zipCode = zip
      this.formData.state = state
      this.formData.city = city
      this.formData.payout = payout
    },
    handleInputValidity (isValid, tagName) {
      this.validInputs[tagName] = isValid
    },
    handleNextStep () {
      // this.$refs.
      switch (this.step) {
        case 'property-zip':
          if (this.validInputs['input-zip'] === true) {
            this.$emit('stepValid', this.formData)
          }
          break
        case 'personal-info':
          if (this.validInputs['f-name'] === true && this.validInputs['l-name'] === true) {
            this.$emit('stepValid', this.formData)
          } else {
            this.$refs.InputFirstName.triggerTouch()
            this.$refs.InputLastName.triggerTouch()
          }
          break
        case 'personal-contacts':
          if (this.validInputs['input-usphone'] === true && this.validInputs['input-email'] === true) {
            this.$emit('stepValid', this.formData)
          } else {
            this.$refs.InputEmail.triggerTouch()
            if (this.validInputs['input-usphone'] !== true) {
              this.$refs.InputUsPhone.triggerTouch()
            }
          }
          break
      }
    },
    nextStep () {
      if (process.env.NODE_ENV === 'production') {
        if (this.$refs.leadDiv.value === '') {
          if (window.LeadiD.token !== '') {
            this.$refs.leadDiv.value = window.LeadiD.token
          }
        }
        this.formData.leadID = this.$refs.leadDiv.value
      } else {
        this.formData.leadID = 'test lead id'
      }
      this.$emit('stepValid', this.formData)
    },
    skipThisStep () {
      this.$emit('stepValid', this.formData)
    }
  }
}
</script>

<style>

</style>
